import "./index.css";
import back from "../../assets/shapes_svg/roledetail/back.svg";
import { Link } from "react-router-dom";

export const Back2 = ({ header, style, to }) => {
  return (
    <>
      <Link className="nav-link" to={to} style={style}>
        <div
          className={
            "option__icon back__icon2" +
            (to === "/product"
              ? " back__icon__product2"
              : to === "/ambition"
              ? " back__icon__ambition2"
              : "")
          }
        ></div>
      </Link>
    </>
  );
};
const Back = ({ header, style, to }) => {
  return (
    <>
      <Link className="nav-link" to={to} style={style}>
        <div
          className={
            "option__icon back__icon" +
            (to === "/product"
              ? " back__icon__product"
              : to === "/ambition"
              ? " back__icon__ambition"
              : "")
          }
        >
          <img className="" src={back} alt="" />
          <h4>{header}</h4>
        </div>
      </Link>
    </>
  );
};

export default Back;
